import { useEffect, useRef, useState } from 'react';
import { Button, message } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import Search from 'antd/es/input/Search';
import useAntdClearButtonA11y from '../../../custom hooks/useAntdClearButtonA11y';

export default function TranscriptSection({
	transcript,
	title = 'Transcript',
	ariaLabel = 'Transcript',
	className = '',
}) {
	useAntdClearButtonA11y();
	const [searchValue, setSearchValue] = useState('');
	const [highlightedTranscript, setHighlightedTranscript] = useState(transcript);
	const [searchError, setSearchError] = useState(null);
	const transcriptRef = useRef(null);

	const highlightText = (text) => {
		if (!searchValue.trim()) {
			setHighlightedTranscript(text);
			return;
		}
		const regex = new RegExp(`(${searchValue})`, 'gi');
		const highlighted = text.replace(
			regex,
			'<mark class="bg-yellow-300">$1</mark>'
		);
		setHighlightedTranscript(highlighted);
	};

	const handleSearch = (value) => {
		if (!value.trim()) {
			setHighlightedTranscript(transcript);
			return;
		}
		const regex = new RegExp(`(${value})`, 'gi');
		const matches = transcript?.match(regex);
		if (!matches?.length) {
			setSearchError(`No results found for "${value}"`);
			setHighlightedTranscript(transcript);
			return;
		}else {
			setSearchError(null);
		}
		setHighlightedTranscript(
			transcript.replace(
				regex,
				'<mark class="bg-yellow-300">$1</mark>'
			)
		);
	};
	useEffect(() => {
		const firstMatch =
			transcriptRef.current?.querySelector('mark');

		if (firstMatch) {
			firstMatch.scrollIntoView({
				behavior: 'smooth',
				block: 'center',
			});
		}
	}, [highlightedTranscript]);

	useEffect(() => {
		highlightText(transcript);
	}, [transcript]);

	const onChangeSearch = (value) => {
		setSearchValue(value);
		if (!value.trim()) {
			setHighlightedTranscript(transcript);
			setSearchError(null);
		}
	}

	const content = (
		<section
			aria-label={ariaLabel}
			className={`w-full border border-gray-300 max-h-fit ${className}`}
		>
			<h1 className='px-3 py-2 text-lg font-bold'>{title}</h1>
			<div className="flex justify-between items-center px-3 py-2 border-b w-full">
				<Search
					placeholder="Search transcript"
					allowClear
					onSearch={handleSearch}
					onChange={(e) => onChangeSearch(e.target.value)}
					enterButton={
						<Button
							type="primary"
							style={{
								backgroundColor: searchValue ? '#1d4ed8' : '#d9d9d9',
								borderColor: searchValue ? '#1d4ed8' : '#d9d9d9',
								color: searchValue ? '#fff' : 'rgba(0, 0, 0, 0.45)',
							}}
							icon={<SearchOutlined aria-hidden="true" />}
							disabled={!searchValue}
							aria-label="Search"
						></Button>
					}
				/>
			</div>
			<span className="px-3 py-1 text-sm text-red-500">{searchError}</span>
			<div className="h-[63vh] pr-0 pb-3">
				<p
					tabIndex={0}
					ref={transcriptRef}
					className="overflow-y-auto h-full mt-3 ml-3 pr-3 mr-0"
					dangerouslySetInnerHTML={{
						__html: highlightedTranscript,
					}}
				/>
			</div>
		</section>
	)
	return content;
}